class FloatingVideo extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('.floating-video__close');
    this.videoElement = this.querySelector('video');
    this.iframeElement = this.querySelector('iframe');
  }

  connectedCallback() {
    // Teleport to body to escape all stacking contexts
    if (this.parentNode !== document.body) {
      document.body.appendChild(this);
      return;
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
    
    // Play video explicitly if it's struggling to autoplay
    if (this.videoElement && this.videoElement.autoplay) {
      const playPromise = this.videoElement.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.warn("Autoplay prevented:", error);
        });
      }
    }
  }

  close(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (!this.classList.contains('is-minimized')) {
      // First click: Minimize it
      this.classList.add('is-minimized');
      
      // Allow clicking the minimized widget to expand it again
      this.addEventListener('click', this.expand.bind(this), { once: true });
    } else {
      // Second click: Completely close it
      
      // Stop the video
      if (this.videoElement) {
        this.videoElement.pause();
      }
      if (this.iframeElement) {
        // Remove src to stop iframe videos
        const src = this.iframeElement.src;
        this.iframeElement.src = '';
        this.iframeElement.src = src;
      }

      // Hide the widget until next refresh
      this.style.display = 'none';
    }
  }

  expand(event) {
    if (event) event.preventDefault();
    
    // Expand the widget back to normal size
    this.classList.remove('is-minimized');
  }
}

if (!customElements.get('floating-video')) {
  customElements.define('floating-video', FloatingVideo);
}
